// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const feedbackInAttachmentIdsMax = 10;

export const feedbackInDescriptionMax = 8000;

export const feedbackInTitleMax = 200;

export const FeedbackIn = zod.object({
  "attachment_ids": zod.array(zod.uuid()).max(feedbackInAttachmentIdsMax).optional(),
  "category": zod.enum(['bug', 'enhancement', 'suggestion', 'question']),
  "description": zod.string().min(1).max(feedbackInDescriptionMax),
  "title": zod.string().min(1).max(feedbackInTitleMax)
});

export type FeedbackIn = zod.input<typeof FeedbackIn>;
export type FeedbackInOutput = zod.output<typeof FeedbackIn>;
